var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-twitter-square",
    "data-name": "Icon awesome-twitter-square",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter-square-2",
    "data-name": "Icon awesome-twitter-square",
    d: "M14.286,2.25H1.714A1.715,1.715,0,0,0,0,3.964V16.536A1.715,1.715,0,0,0,1.714,18.25H14.286A1.715,1.715,0,0,0,16,16.536V3.964A1.715,1.715,0,0,0,14.286,2.25ZM12.539,7.921c.007.1.007.2.007.3a6.619,6.619,0,0,1-6.664,6.664,6.634,6.634,0,0,1-3.6-1.05,4.935,4.935,0,0,0,.564.029,4.7,4.7,0,0,0,2.907-1,2.345,2.345,0,0,1-2.189-1.625A2.524,2.524,0,0,0,4.625,11.2,2.343,2.343,0,0,1,2.75,8.9V8.871a2.341,2.341,0,0,0,1.057.3,2.337,2.337,0,0,1-1.043-1.95,2.313,2.313,0,0,1,.318-1.182,6.651,6.651,0,0,0,4.829,2.45,2.347,2.347,0,0,1,4-2.139,4.59,4.59,0,0,0,1.486-.564,2.336,2.336,0,0,1-1.029,1.289,4.661,4.661,0,0,0,1.35-.364A4.93,4.93,0,0,1,12.539,7.921Z",
    transform: "translate(0 -2.25)",
    fill: "#3787c9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2994b841da63159b55187f6b53b5a505.svg";
export { ForwardRef as ReactComponent };